export default __webpack_public_path__ + "locales/si/InviteDialog.json?hash=41bf64760c837729e267c0d616488a29";